// Copyright (c) StrangeBee 2023

import { classList } from '@Helpers/className';
import { Radio, RadioProps } from 'antd';
import React, { ReactElement } from 'react';
import { Button } from './Button';
import { Group } from './Group';

import './THRadio.scss';

type THRadioProps = RadioProps;

export const THRadio = ({ className, ...props }: THRadioProps): ReactElement => (
    <Radio className={classList('th-radio', className)} {...props} />
);

THRadio.Group = Group;
THRadio.Button = Button;
